var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLighting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    height: 14,
    width: 14,
    id: "Flash-2--Streamline-Core.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Flash 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flash-2--flash-power-connect-charge-electricity-lightning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 0.5v5h3.5l-5.5 8v-5H2.5L8 0.5Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting);
export default __webpack_public_path__ + "static/media/lighting.d695a6f0cc6ba7fb0c4127581e9d3c0d.svg";
export { ForwardRef as ReactComponent };